const demo_app = {
    notification: 'Dica: Crie uma conta primeiro para testar a experiência de login.',
};
export default demo_app;
